
interface finderType{
  src: string,
  alt: string,
  className: string
}
export function ImgFinder ({ src, alt, className = ''}:finderType) {
  return (
    //Importar la imagen desde assets
    <img
      src={require(`assets/img/${src}`)}
      alt={alt}
      className={className}
    />
  )
}